import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import validator from 'validator';

import HarvestingProcedureCard from './HarvestingProcedureCard';
import ProcessContext from '../../../contexts/process/ProcessContext';
import HarvestingProceduresContext from '../../../contexts/management/harvestingProcedures/HarvestingProceduresContext';
import Loading from '../../ui-elements/Loading';
import { HELP_DESK_LINK } from '../../../constants/helpDesk';

const HarvestingProcedureSelection = ({ forwardTo, harvestingProcedureId }) => {
    const { activeProcessId, continueProcess, handleError, isNetworkError, notifyError, setSelection } = useContext(ProcessContext);
    const { allHarvestingProcedures} = useContext(HarvestingProceduresContext);
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();
    
    useEffect(() => {
        if (harvestingProcedureId && validator.isUUID(harvestingProcedureId)) {
          setLoading(true);
          setSelection(harvestingProcedureId)
          continueProcess(activeProcessId, harvestingProcedureId)
            .then(() => {
              if (forwardTo) {
                navigate(forwardTo);
              }
            })
            .catch((error) => {
              setLoading(false);
              if (isNetworkError(error)) {
                handleError(error);
              } else {
                handleError(
                  error,
                  <>We have encountered a problem while continuing the Process. Please contact the support team {HELP_DESK_LINK}.</>
                );
              }
              console.error(error);
            });
        }
      }, [
        harvestingProcedureId
      ]);
      
    const proceed = async (harvestingProcedureIdRef) => {
        try {
            setSelection(harvestingProcedureIdRef)
            await continueProcess(activeProcessId, harvestingProcedureIdRef);
            if (forwardTo) {
                navigate(forwardTo);
            }
        } catch (error) {
            if (/p(?=[0-9])/i.test(error.message)) {
                notifyError(`You tried to enter an invalid panel. Please select a panel between 1 and ${import.meta.env.VITE_MAX_PANEL_NUMBER}`);
            }
            console.error(error);
        }
    };


    return (loading  ?
        <Loading fullScreen /> :
        <div className='harvesting-procedure-selection'>
            {allHarvestingProcedures &&
                allHarvestingProcedures.slice().sort((a, b) => {
                    var nameA = a.type.toUpperCase();
                    var nameB = b.type.toUpperCase();
                    if (nameA < nameB)   {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                }).map((hp) => {
                        // create a class name based on the type
                        const classNameBase = "fai-harvesting-procedure-";
                        let className = classNameBase;
                    
                        // Convert the type to a class name
                        for (let i = 0; i < hp.type.length; i++) {
                            if (hp.type[i] === hp.type[i].toUpperCase() && i !== 0) {
                                className += '-';
                            }
                            className += hp.type[i].toLowerCase();
                        }
                    
                        return (
                            <HarvestingProcedureCard
                                key={hp.id}
                                className={className} // Use the generated class name
                                text={hp.type.replace(/([A-Z])/g, ' $1').trim()} // Format the type for display
                                onClickCallback={() => proceed(hp.id)}
                            />
                        );
                    })
                    
                }
        </div>
    )
}

export default HarvestingProcedureSelection
